import axios from 'axios'

class NotificationResendService {
    constructor(apiUrl) {
        this.apiUrl = apiUrl
    }

    /**
     * @author Pedro Ramos
     * @description Handle an event to resend notification to sign
     * @date 08-11-2022
     * @param {number} signRequestId
     * @param {String} email
     * @returns {Object}
     * @memberof NotificationResendService
     */

    async resendNotification(signRequestId, email, token) {
        let response = await axios.post(
            `${this.apiUrl}/notification-resend`,
            {
                signRequestId: signRequestId,
                email: email
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        );
        return response.data;
    }
}

export { NotificationResendService as default } 